/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid200,
  PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid400,
  PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid401,
  PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid404,
  PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid500,
  PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidMutationRequest,
  PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidMutationResponse,
  PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidPathParams,
} from "../../types/pecegePayCreditCardController/PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid.ts";
import { creditCardCreateIdResponseViewModelSchema } from "../creditCardCreateIdResponseViewModelSchema.ts";
import { creditCardLimitRequestViewModelSchema } from "../creditCardLimitRequestViewModelSchema.ts";

export const postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidPathParamsSchema =
  z.object({
    courseFinancialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid200Schema =
  z.lazy(
    () => creditCardCreateIdResponseViewModelSchema,
  ) as unknown as ToZod<PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid400Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid401Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid404Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid500Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid500>;

export const postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidMutationRequestSchema =
  z.lazy(
    () => creditCardLimitRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidMutationRequest>;

export const postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidMutationResponseSchema =
  z.lazy(
    () => postApiV1PecegepayCreditcardSaveIdCoursefinancialpersonid200Schema,
  ) as unknown as ToZod<PostApiV1PecegepayCreditcardSaveIdCoursefinancialpersonidMutationResponse>;
